// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2azjF","sendOtp":"AuthorizeToLogin_sendOtp__2sOtX"};